function SubsystemsController($uibModal) {
  const ctrl = this;

  ctrl.$onInit = () => {};

  ctrl.openSubsystemModal = (category, car) => {
    ctrl.subSystemObject = {
      name: category.name,
      cis: category.ci_values,
      assets: category.assets,
      carNumber: car.carId,
      trainId: car.trainId,
    };
    const modalInstance = $uibModal.open({
      component: 'subsystemModal',
      windowClass: 'subSystemWindow',
      resolve: {
        subSystemObject: function () {
          return ctrl.subSystemObject;
        },
      },
    });

    modalInstance.result.then(() => {}, () => {});
  };
}

angular
  .module('dashboardGridletDirectives')
  .controller('SubsystemsController', SubsystemsController);
